import { BulkAssignment } from '@lp/features/BulkAssignment/BulkAssignment';

export const BulkAssignmentPage = () => {
  return <BulkAssignment />;
};
